export default "__VITE_ASSET__nNShiwWM__"